import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/icon-topic-label.png'


const _withScopeId = n => (_pushScopeId("data-v-68861716"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "talk-swiper"
}
const _hoisted_2 = { class: "talk-swiper-item" }
const _hoisted_3 = { class: "talk-swiper-item-left" }
const _hoisted_4 = { class: "talk-swiper-item-left-content" }
const _hoisted_5 = { class: "talk-swiper-item-left-content__title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_7 = { class: "talk-swiper-item-left-content__text" }
const _hoisted_8 = { class: "talk-swiper-item-left-content__hots" }

import {
  ref,
  reactive,
  computed,
  onMounted,
} from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { List, Button } from 'vant'
import MImage from '@/components/MImage/MImage.vue'
import MWaterFall2 from './components/MWaterFall2/MWaterFall2.vue'
// import MArticle2 from './components/MArticle2/MArticle2.vue'
import FooterTips from '@/views/components/FooterTips/FooterTips.vue'
import qs from 'qs'
import { getInnerTextContent } from '@/utils/common'
import { getTopicList, getTopicTypeList } from '@/api/hots'


export default /*#__PURE__*/_defineComponent({
  __name: 'TalkList',
  props: {
  searchValue: String,
},
  setup(__props, { expose }) {

const props = __props;


const router = useRouter()
const route = useRoute()
const listRef = ref(null)
const itemRef = ref(null)
const resourcesUrl = process.env.VUE_APP_RESOURCES_URL
const state = reactive({
  loading: false,
  finished: false,
  pagination: {
    pageNum: 1,
    pageSize: 10,
  },
  // searchValue: '',
  array: [], //定义空数组存储元素高度
  topicTypeList: [],
  topicList: [],
  isSearch: false, // 是否显示搜索区域
})

const topicList = computed(() => {
  if (!state.isSearch) return state.topicList
  const res = state.topicList.map((item) => ({
    ...item,
    details: props.searchValue
      ? getInnerTextContent(item.details)
          .substr(0, 30)
          .replace(
            props.searchValue,
            `<span class="highlight" style="color: #cb9e52">${props.searchValue}</span>`
          )
      : item.details,
  }))
  console.log('res==>', res)
  return res
})

onMounted(() => {
  fetchTopicTypeList()
})

const fetchTopicTypeList = async () => {
  const { dataList = [] } = await getTopicTypeList()
  state.topicTypeList = dataList
}

const fetchList = async () => {
  const res = await getTopicList({
    ...state.pagination,
    details: props.searchValue,
  })
  state.topicList = [...state.topicList, ...res.data.list]
  state.finished = res.data.isLastPage
  state.pagination.pageNum++
  state.loading = false
}

const handleSearch = () => {
  state.pagination.pageNum = 1
  state.topicList = []
  fetchList()
  if (props.searchValue) {
    state.isSearch = true
    // state.topicList = state.topicList.map((item) => ({
    //   ...item,
    //   details: formatSearch(
    //     item.details,
    //     // eslint-disable-next-line no-useless-escape
    //     '(?<=(<.*>))[^<>]*(pattern).*?(?=<\/)'
    //   ),
    // }))
  } else {
    state.isSearch = false
  }
}
const handleRouterToDetail = (item) => {
  console.log('value==>', item)
  router.push({
    path: `/talk-detail/${item.id}`,
    query: { detailType: 2, refresh: true },
  })
}
const formatSearch = (origin: string, search: string) => {
  return origin.replace(
    new RegExp(search, 'ig'),
    ($1) => `<span class="light">${$1}</span>`
  )
}

expose({
  handleSearch,
})

return (_ctx: any,_cache: any) => {
  const _component_MImg = _resolveComponent("MImg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!state.isSearch)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.topicTypeList, (item) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: item.id,
              to: {
          path: `/talk-list-detail/${item.id}`,
          query: { detail: _unref(qs).stringify(item) },
        }
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_MImg, {
                    class: "item-background",
                    src: item.iconUrl
                  }, null, 8, ["src"]),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(MImage, {
                      src: item.iconUrl
                    }, null, 8, ["src"]),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createTextVNode(" " + _toDisplayString(item.topicType), 1)
                      ]),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(item.synopsis), 1),
                      _createElementVNode("div", _hoisted_8, _toDisplayString(item.topicCount) + " 热议 ", 1)
                    ])
                  ])
                ])
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(List), {
      loading: state.loading,
      "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((state.loading) = $event)),
      finished: state.finished,
      onLoad: fetchList
    }, {
      default: _withCtx(() => [
        (_unref(topicList).length)
          ? (_openBlock(), _createBlock(MWaterFall2, {
              key: 0,
              listData: _unref(topicList)
            }, null, 8, ["listData"]))
          : _createCommentVNode("", true),
        (state.finished)
          ? (_openBlock(), _createBlock(FooterTips, { key: 1 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["loading", "finished"])
  ], 64))
}
}

})